import { useEffect, useState } from 'react';
import useLocalStorage from "@hooks/useLocalStorage";
export var CSR_LOADED_EVENT = 'csrFinishLoadingEvent';
var addBodyClass = function addBodyClass() {
  if (!document.body.classList.contains("isFirstInteraction")) {
    document.body.classList.add("isFirstInteraction");
  }
};
export var external_first_interaction = function external_first_interaction() {
  console.log('external_first_interaction');
  setTimeout(function () {
    window.dispatchEvent(new CustomEvent(CSR_LOADED_EVENT, {
      detail: null
    }));
    addBodyClass();
    window.tryToRunDelayedAction();
  }, 100);
};
var useIsFirstInteraction = function useIsFirstInteraction() {
  var _useState = useState(false),
    isFirstInteraction = _useState[0],
    setIsFirstInteraction = _useState[1];
  var _useLocalStorage = useLocalStorage(false),
    setLocalStorage = _useLocalStorage.setLocalStorage,
    getLocalStorage = _useLocalStorage.getLocalStorage;
  var _finalizeFirstInteraction = function finalizeFirstInteraction() {
    window.removeEventListener(CSR_LOADED_EVENT, _finalizeFirstInteraction);
    if (!isFirstInteraction) {
      setIsFirstInteraction(true);
      addBodyClass();
      window.isFirstInteraction = true;
      setLocalStorage('isFirstInteraction', 'true');
    }
  };
  useEffect(function () {
    if (window.isFirstInteraction || getLocalStorage('isFirstInteraction') === 'true') {
      setIsFirstInteraction(true);
      return;
    }
    window.addEventListener(CSR_LOADED_EVENT, _finalizeFirstInteraction);
    return function () {
      window.removeEventListener(CSR_LOADED_EVENT, _finalizeFirstInteraction);
      _finalizeFirstInteraction();
    };
  }, []);
  return isFirstInteraction;
};
export default useIsFirstInteraction;